exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-dialog[data-v-36f85c42] .el-dialog__body{max-height:calc(100vh - 250px);overflow-y:auto}.upload-voucher-image[data-v-36f85c42] .el-upload--picture-card{width:102px;height:102px;line-height:108px}.upload-voucher-image[data-v-36f85c42] .el-upload-list__item{width:102px;height:102px}\n", ""]);

// exports
